import QRCode from 'react-qr-code';

import IconDate from '../assets/date.svg';
import IconTime from '../assets/time.svg';
import IconTmp from '../assets/tmp.svg';
import IconUser from '../assets/user.svg';

import Moment from 'react-moment';

function TestFrom({ user, place, checkin }) {
  return (
    <div className="ticket">
      <div className="px-4 py-2 text-gray-800">
        <div className="flex flex-col bg-white border rounded-md shadow-md">
          <div className="py-2 px-4 flex flex-col rounded-t-lg status --pass">
            <p className="self-start text-base text-gray-100">CHECKIN, SNRU</p>
            <h5 className="self-start font-extrabold text-2xl text-gray-100">
              {place.display}
            </h5>
          </div>
          <div className="py-2 px-4 flex flex-col">

            <p className="self-start font-bold text-sm md:text-lg text-gray-500">
              เวลาเช็คอิน
            </p>

            <div className="flex text-lg justify-between my-2 md:text-xl">
              <img src={IconDate} alt="date" width={24} height={24} />
              <p className="font-bold text-red-800">
                <Moment format="MM-DD-YYYY">
                  {checkin.profile.checkin_date}
                </Moment>
              </p>
            </div>

            <div className="flex justify-between my-2 text-lg md:text-xl">
              <img src={IconTime} alt="time" width={24} height={24} />
              <p className="font-bold text-red-800">
                <Moment format="HH:mm:ss">
                  {checkin.profile.checkin_date}
                </Moment>
              </p>
            </div>

            <div className="flex justify-between my-2 text-lg md:text-xl">
              <img src={IconTmp} alt="time" width={24} height={24} />
              <p className="font-bold text-red-800">
                {checkin.profile.userTemp}
              </p>
            </div>
          </div>

          <div className="py-2 px-4 flex flex-col">
            <p className="self-start font-bold text-sm md:text-lg text-gray-500">
              ผู้ใช้งาน
            </p>
            <div className="flex justify-between my-2 text-lg md:text-xl">
              <img src={IconUser} alt="time" width={24} height={24} />
              <p className="font-bold text-red-800">
                {user.profile.display} ( {user.profile.agency} )
              </p>
            </div>
          </div>

          <hr className="border-dashed border-2 border-gray-400" />

          <div className="py-2 px-4 flex-col flex text-center">
            <QRCode
              value={user.profile.username ? user.profile.username : user.profile.citizen_id}
              className="mx-auto m-4 w-full object-cover"
              size={300}
            />
            <p className="font-bold text-sท p-2">รหัสผู้ใช้งาน</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TestFrom;
